// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.matching-board-page__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-3, 12px);
  padding: var(--space-4, 16px);
  padding-bottom: var(--space-3, 12px);
  border-bottom: 2px solid var(--color-fire-600, #c76a1d);
}

.matching-board-page__heading {
  display: flex;
  align-items: center;
  gap: var(--space-2, 8px);
  min-width: 0;
}

.matching-board-page__back {
  flex-shrink: 0;
  min-width: 40px;
  min-height: 40px;
  padding: 0 12px;
  font-size: 18px;
  line-height: 1;
}

.matching-board-page__header .ttbPageTitle {
  white-space: nowrap;
}

.matching-board-page__create-button {
  font-size: 14px;
  padding: 10px 16px;
  height: auto;
  min-width: auto;
  white-space: nowrap;
  width: auto;
}

.matching-board-page__content {
  display: flex;
  flex-direction: column;
  gap: var(--space-3, 12px);
  padding: var(--space-4, 16px);
}

.matching-board-page__day {
  display: flex;
  flex-direction: column;
  gap: var(--space-2, 8px);
}

.matching-board-page__day-title {
  margin: 0;
  font-family: var(--font-heading, inherit);
  font-size: 16px;
  font-weight: 800;
  color: var(--color-parchment-100, #f5efe7);
  text-transform: capitalize;
  text-decoration: underline;
  text-decoration-color: var(--color-fire-500, #d85a1f);
  text-decoration-thickness: 2px;
  text-underline-offset: 4px;
}

@media (min-width: 768px) {
  .matching-board-page__day {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    align-items: start;
  }

  .matching-board-page__day-title {
    grid-column: 1 / -1;
  }
}

@media (min-width: 1024px) {
  .matching-board-page__day {
    grid-template-columns: repeat(auto-fill, minmax(340px, 1fr));
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/MatchingBoard/MatchingBoardPage.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,yBAAyB;EACzB,6BAA6B;EAC7B,oCAAoC;EACpC,uDAAuD;AACzD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,wBAAwB;EACxB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA;EACE,SAAS;EACT,yCAAyC;EACzC,eAAe;EACf,gBAAgB;EAChB,0CAA0C;EAC1C,0BAA0B;EAC1B,0BAA0B;EAC1B,qDAAqD;EACrD,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE;IACE,aAAa;IACb,gDAAgD;IAChD,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,4DAA4D;EAC9D;AACF","sourcesContent":[".matching-board-page__header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: var(--space-3, 12px);\n  padding: var(--space-4, 16px);\n  padding-bottom: var(--space-3, 12px);\n  border-bottom: 2px solid var(--color-fire-600, #c76a1d);\n}\n\n.matching-board-page__heading {\n  display: flex;\n  align-items: center;\n  gap: var(--space-2, 8px);\n  min-width: 0;\n}\n\n.matching-board-page__back {\n  flex-shrink: 0;\n  min-width: 40px;\n  min-height: 40px;\n  padding: 0 12px;\n  font-size: 18px;\n  line-height: 1;\n}\n\n.matching-board-page__header .ttbPageTitle {\n  white-space: nowrap;\n}\n\n.matching-board-page__create-button {\n  font-size: 14px;\n  padding: 10px 16px;\n  height: auto;\n  min-width: auto;\n  white-space: nowrap;\n  width: auto;\n}\n\n.matching-board-page__content {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-3, 12px);\n  padding: var(--space-4, 16px);\n}\n\n.matching-board-page__day {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-2, 8px);\n}\n\n.matching-board-page__day-title {\n  margin: 0;\n  font-family: var(--font-heading, inherit);\n  font-size: 16px;\n  font-weight: 800;\n  color: var(--color-parchment-100, #f5efe7);\n  text-transform: capitalize;\n  text-decoration: underline;\n  text-decoration-color: var(--color-fire-500, #d85a1f);\n  text-decoration-thickness: 2px;\n  text-underline-offset: 4px;\n}\n\n@media (min-width: 768px) {\n  .matching-board-page__day {\n    display: grid;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    align-items: start;\n  }\n\n  .matching-board-page__day-title {\n    grid-column: 1 / -1;\n  }\n}\n\n@media (min-width: 1024px) {\n  .matching-board-page__day {\n    grid-template-columns: repeat(auto-fill, minmax(340px, 1fr));\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
